export const teacherDaySkus = [
  'V9267',
  'V10452',
  // voan(s)
  'V1852',
  'V1867',
  'V1882',
  'V10222',
  'V9181',
  'V9183',
  'V9185',
  // cup(s)
  'V8321',
  'V8323',
  'V8327',
  'V10304',
  'V10305',
  // sunshine
  'V9041',
  'V9043',
  'V9045',
  'V10306',
  'V10307',
  // sym
  'V9227',
  'V9229',
  'V9231',
  // sukem
  'V8838'
]
export function getTeacherDayGiftSkusMap() {
  const auto = ['V9262'] // que mica
  const picky = ['V2863', 'V2865'] // que giấy tùy chọn

  return {
    auto,
    picky,
    all: [...auto, ...picky]
  }
}

export const tetCookieSkus = ['V9276', 'V9277', 'V9278']

// Bánh trung thu 2025
export const mooncake2025Set4Skus = ['B12740', 'B12741']
export const mooncake2025Set2Skus = ['B12742', 'B12743', 'B12744', 'B12745']
export const mooncake2025SingleSkus = [
  'B12707',
  'B12708',
  'B12709',
  'B12710',
  'B12711',
  'B12712',
  'B12713',
  'B12717',
  'B12732',
  'B12733',
  'B12734',
  'B12735',
  'B12736',
  'B12737',
  'B12738',
  'B12739'
]
export const mooncake2025Skus = [
  ...mooncake2025Set4Skus,
  ...mooncake2025Set2Skus,
  ...mooncake2025SingleSkus
]

// SKU hộp con bánh trung thu để tặng
export const mooncakeGiftBoxSkus = ['B7310', 'B7309']

const vltCakeSkus = ['V9423', 'V9424']
const vltBoxSkus = ['V9401', 'V9403', 'V9163']
export type ValentineGiftType = 'mica' | 'card'
export const valentineSkusMap: Record<ValentineGiftType, string[]> = {
  mica: [...vltBoxSkus, ...vltCakeSkus], // mica que cắm
  card: ['V9421', 'V9422'] // mousse
}
export function getValentineGiftSkusMap() {
  const result: Record<ValentineGiftType, string[]> = {
    mica: ['V9400'], // que cắm
    card: ['V2225'] // thiệp
  }
  return result
}

export type WomenDaysGiftType = 'card' | 'sparkle'
export const WOMEN_DAY_GIFT_SKUS_MAP: Record<WomenDaysGiftType, string[]> = {
  card: ['V2242'], // thiệp
  sparkle: ['V2860'] //nến pháo bông tăm
}

export const list3042025Skus = [
  'V2709',
  'V2711',
  'V2713',
  //
  'V1504',
  'V1505',
  'V1530',
  // set new
  'V9641',
  'V9642',
  'V9643'
]
export const list3042025GiftSkus = ['V9142'] // vnflag

export const listMotherDaySkus = [
  'V9679',
  'V9680',
  'V9681',
  'V9682',
  'V9683',
  'V9684',
  'V9685',
  'V9686',
  // old
  'V8840',
  'V8842',
  'V8844',
  // bo thiec
  'V9665',
  'V9666',
  'V9667'
]

export const listMotherDayGiftSkus = ['V1443'] // que mica

// father day
export const listFatherDaySkus = [
  'V9812',
  'V9813',
  'V9814',
  'V9594',
  'V9595',
  'V9596',
  'V8736',
  'V8738',
  'V8740',
  'V9065',
  'V9067',
  'V9069',
  'V8832',
  'V8834',
  'V8836',
  'V9630'
]

export const listFatherDayGiftSkus = ['V8728']
